import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';
import { useTheme } from './ThemeContext.tsx'; // Import useTheme

interface AddChecklistPopupProps {
  open: boolean;
  onClose: () => void;
  onAdd: (checklistName: string) => void;
}

function AddChecklistPopup({ open, onClose, onAdd }: AddChecklistPopupProps) {
  const [checklistName, setChecklistName] = useState<string>('');
  const { theme } = useTheme(); // Call useTheme here, once at the top level of the component

  const handleAddClick = () => {
    if (checklistName.trim()) {
      onAdd(checklistName);
      setChecklistName(''); // Clear input after adding
    }
  };

  const handleClose = () => {
    setChecklistName(''); // Clear input on close
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          backgroundColor: theme.colors.whiteCardBackground,
          color: theme.colors.darkText,
          borderRadius: theme.borderRadius,
          boxShadow: theme.boxShadow,
          border: `1px solid ${theme.colors.borderColor}`,
        }
      }}
    >
      <DialogTitle sx={{ color: theme.colors.darkText, fontWeight: 'bold' }}>Add New Checklist</DialogTitle>
      <DialogContent sx={{ backgroundColor: theme.colors.whiteCardBackground }}>
        <TextField
          autoFocus
          margin="dense"
          label="Checklist Name"
          type="text"
          fullWidth
          variant="outlined"
          value={checklistName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setChecklistName(e.target.value)}
          onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') {
              handleAddClick();
            }
          }}
          InputLabelProps={{
            sx: { color: theme.colors.lightText }
          }}
          InputProps={{
            sx: { color: theme.colors.darkText, backgroundColor: theme.colors.lightGrayBackground }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ backgroundColor: theme.colors.whiteCardBackground }}>
        <Button onClick={handleClose} sx={{ color: theme.colors.lightText }}>Cancel</Button>
        <Button onClick={handleAddClick} disabled={!checklistName.trim()} variant="contained" sx={{ backgroundColor: theme.colors.primaryRed, color: theme.colors.whiteCardBackground }}>Add</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddChecklistPopup;
